import React from "react";

const InboxDetail = (props) => {
  const HtmlDecode = (content) => {
    const e = document.createElement("divEmailDescription");
    e.innerHTML = content;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  };

  const InboxPopup = () => {
    props.parentCallback(true);
  };

  return (
    <div className="overlay">
      <div className="popup">
        <div className="popup__header">
          <h3>Description</h3>
          <span
            className="close"
            role="button"
            onClick={() => InboxPopup(false)}
          >
            ×
          </span>
        </div>
        <div className="content">
          <div className="popup__body">
            <div className="panCont" style={{ margin: "5px 0px" }}>
              <div className="InputTable" style={{ padding: "0px 0px 15px" }}>
                <div className="row">
                  <div
                    className="col-12"
                    dangerouslySetInnerHTML={{
                      __html: HtmlDecode(props.data),
                    }}
                    style={{ marginLeft: "2%", lineHeight: "18px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InboxDetail;
